<script lang="ts" setup>
import CheckboxToggle from "@/components/form/CheckboxToggle.vue"
import { injectMandatory, type ListState } from "@/vf"
import { type ModuleConfiguration } from "@/vf/module-configuration"
import { computed, inject, type Ref } from "vue"

const config = injectMandatory<Ref<ModuleConfiguration>>(
    "module-config",
    "VbListCustomizeFields: ModuleConfiguration is not provided",
)
const listState = inject("list-state") as ListState
const fieldGroups = computed(() => config.value.list.fieldGroups)
</script>

<template>
    <div class="open-row" style="overflow: hidden">
        <div class="open-row-container">
            <div class="d-flex flex-row flex-wrap">
                <div v-for="group of fieldGroups" class="mr-5" :key="group.name">
                    <CheckboxToggle class="toggle-primary-dark" v-model="listState.customizeFields[group.name].enabled">
                        <b>{{ $t(group.title) }}</b>
                    </CheckboxToggle>

                    <div v-for="field in group.fields" :key="field.name">
                        <CheckboxToggle
                            v-model="listState.customizeFields[group.name].fields[field.name].enabled"
                            v-if="typeof field.title === 'string'"
                        >
                            {{ $t(field.title) }}
                        </CheckboxToggle>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-primary" @click="listState.resetCustomizeFields(true, true)">
                    alle auswählen
                </button>
                <button class="btn btn-primary" @click="listState.resetCustomizeFields(true)">
                    Standard zurücksetzen
                </button>
            </div>
        </div>
    </div>
</template>
